import {
  FULLMENT_INPROGRESS,
  DECLINE_OFFERS,
  OFFER,
  GET_NEXT_CREDIT_CHECK,
  AUTH_PAGE_KEY,
  GET_NEXT_CHALLANGE,
  GET_NEXT_APPL_REJ,
  GET_NEXT_CREDIT_CHECK_CANCEL,
  GET_NEXT_DEF,
  GET_NEXT_CREDIT_CHECK_DEF,
  GET_NEXT_CREDIT_CHECK_DEC,
  GET_NEXT_CREDIT_CHECK_REF_NOMATCH,
  GET_NEXT_APP_EXPIRE,
  GET_NEXT_PENDING_STATEMENTS_FAIL,
  GET_NEXT_PENDING_STATEMENTS,
  CONFIRM_AUTH_CODE,
  GET_NEXT_SETUP_IN_PROGRESS_ERROR,
  GET_NEXT_APPLICANT_WAITING_REFER,
  SECONDARY_APPLICANT_ON_HOLD_TASK,
  ID_CHECK_CANT_BE_DONE,
  OFFER_CASE_ID,
  SAVE_AND_RESUME_CAPTURE
} from '../../utils/constants';
import { redirectToAlmostTherePage } from '../oldSignatories';
import {
  redirerctToAuthPage,
  saveEnterAuthForm,
  redirectToDeclinePage,
  technicalErrorPage,
  redirectToCreditCheckNoMatch,
  redirectToDefferedPage,
  redirectToPendingStatement,
  redirectToSetupInProgressPage,
  redirectToPendingStatementFail,
  redirectToPrimaryApplicantWaitingPage,
  redirectToSecondaryApplicantWaitingPage,
  redirerctToIDVChallengeFail,
  redirectToIDVCheck,
  redirectToPage
} from '../../store/dataCapture';
import { getHrefOnBrowserLoad, setResumeTaskUriHref, getStartPage } from '../../utils';
import { parseUri } from '../../utils/caseParseUtil';
export const GET_NEXT_TASK_URI_KEYS = [
  OFFER,
  GET_NEXT_CHALLANGE,
  AUTH_PAGE_KEY,
  GET_NEXT_CREDIT_CHECK_REF_NOMATCH,
  GET_NEXT_CREDIT_CHECK_DEF,
  GET_NEXT_CREDIT_CHECK,
  GET_NEXT_APP_EXPIRE,
  GET_NEXT_DEF,
  CONFIRM_AUTH_CODE,
  GET_NEXT_SETUP_IN_PROGRESS_ERROR,
  GET_NEXT_PENDING_STATEMENTS_FAIL,
  GET_NEXT_PENDING_STATEMENTS,
  FULLMENT_INPROGRESS,
  GET_NEXT_APPLICANT_WAITING_REFER,
  SECONDARY_APPLICANT_ON_HOLD_TASK,
  ID_CHECK_CANT_BE_DONE
].concat(DECLINE_OFFERS);

const TASK_URI = 'task_uri';
/* eslint-disable complexity */
export const redirectBasesOnTaskUri = (task_uri, linkCode) => {
  //as per existing functionality
  if (task_uri) {
    const { reason, action, task } = parseUri(task_uri);
    setResumeTaskUriHref(reason || action || task);

    switch (getNextPage(task_uri)) {
      case FULLMENT_INPROGRESS:
        return getNextAction(redirectToAlmostTherePage);
      case OFFER:
        return getNextAction(saveEnterAuthForm);
      case CONFIRM_AUTH_CODE:
      case AUTH_PAGE_KEY:
        return check3dChallengeAndRedirect();
      case GET_NEXT_APPL_REJ:
      case GET_NEXT_CREDIT_CHECK_CANCEL:
      case GET_NEXT_CREDIT_CHECK_DEC:
        return getNextAction(redirectToDeclinePage);
      case GET_NEXT_CHALLANGE:
        return getNextAction(redirectToIDVCheck);
      case GET_NEXT_DEF:
        return getNextAction(redirectToDefferedPage);
      case ID_CHECK_CANT_BE_DONE:
      case GET_NEXT_CREDIT_CHECK_REF_NOMATCH:
        return getNextAction(redirectToCreditCheckNoMatch);
      case GET_NEXT_APP_EXPIRE:
      case GET_NEXT_CREDIT_CHECK:
        if (linkCode) {
          return getNextAction(redirectToSecondaryApplicantWaitingPage);
        }
        return getNextAction(redirectToDefferedPage);
      case GET_NEXT_PENDING_STATEMENTS:
        return getNextAction(redirectToPendingStatement);
      case GET_NEXT_PENDING_STATEMENTS_FAIL:
        return getNextAction(redirectToPendingStatementFail);
      case GET_NEXT_SETUP_IN_PROGRESS_ERROR:
        return getNextAction(redirectToSetupInProgressPage);
      case GET_NEXT_APPLICANT_WAITING_REFER:
        return getNextAction(redirectToPrimaryApplicantWaitingPage);
      case SECONDARY_APPLICANT_ON_HOLD_TASK:
        return getNextAction(redirectToSecondaryApplicantWaitingPage);
      default:
        if ((reason || action || task) === SAVE_AND_RESUME_CAPTURE) {
          return {
            nextAction: redirectToPage(getStartPage()),
            loading: false
          };
        }
        return getNextAction(technicalErrorPage);
    }
  } else {
    return getNextAction(technicalErrorPage);
  }
};

export const validateTaskUriToRedirect = taskUri =>
  getHrefOnBrowserLoad()
    .toLowerCase()
    .indexOf(taskUri) > -1;

const getNextAction = action => {
  return action
    ? {
        nextAction: action(),
        loading: false
      }
    : { loading: false };
};
const check3dChallengeAndRedirect = () => {
  const resumeHref = getHrefOnBrowserLoad();
  if (resumeHref.indexOf(TASK_URI) > -1 && resumeHref.indexOf(OFFER_CASE_ID) > -1) {
    return getNextAction(redirerctToAuthPage);
  }
  return getNextAction(redirerctToIDVChallengeFail);
};

const getNextPage = uri => GET_NEXT_TASK_URI_KEYS.filter(v => uri.toLowerCase().indexOf(v) > -1)[0];
